import type { OrderDetails } from '@/entities/order/model'
import { useZebraBarcodeEnabled } from '@/entities/state/model'
import { requiresNoBarcodeCompletionConfirm } from '@/features/order/lib/order.zebraScan'
import { useNoBarcodeConfirmStore } from './noBarcodeConfirm.store'

/**
 * BD-8589: completion paths ask `requiresConfirm` first and, when it is true, hand the
 * rest of their flow to `requestConfirm` so it only runs once the team member confirms.
 */
export function useNoBarcodeCompletionConfirm() {
  const zebraBarcodeEnabled = useZebraBarcodeEnabled()
  const requestConfirm = useNoBarcodeConfirmStore(state => state.request)

  function requiresConfirm(orders: OrderDetails[], action: string) {
    return requiresNoBarcodeCompletionConfirm({
      zebraBarcodeEnabled,
      action,
      orders,
    })
  }

  return { requiresConfirm, requestConfirm }
}
